"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoAuth = void 0;
const errors_1 = require("../util/errors");
class NoAuth {
    async getToken() {
        return null;
    }
    async getTokenType() {
        return null;
    }
    async getClaim(claim) {
        const classname = this.constructor.name;
        throw new errors_1.ConfigurationError(`${classname}.getClaim('${claim}') was called, but ${classname} doesn't implement claims`);
    }
}
exports.NoAuth = NoAuth;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm9uZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hdXRoL25vbmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsMkNBQW9EO0FBSXBELE1BQU0sTUFBTTtJQUNWLEtBQUssQ0FBQyxRQUFRO1FBQ1osT0FBTyxJQUFJLENBQUM7SUFDZCxDQUFDO0lBRUQsS0FBSyxDQUFDLFlBQVk7UUFDaEIsT0FBTyxJQUFJLENBQUM7SUFDZCxDQUFDO0lBRUQsS0FBSyxDQUFDLFFBQVEsQ0FBSSxLQUFhO1FBQzdCLE1BQU0sU0FBUyxHQUFHLElBQUksQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDO1FBQ3hDLE1BQU0sSUFBSSwyQkFBa0IsQ0FDMUIsR0FBRyxTQUFTLGNBQWMsS0FBSyxzQkFBc0IsU0FBUywyQkFBMkIsQ0FDMUYsQ0FBQztJQUNKLENBQUM7Q0FDRjtBQUVRLHdCQUFNIn0=